import { EventBus } from "../event-bus";
import router from "../router/index";

export class Error {
    public static handleError(err: any): void {
        console.log(err);
        if (err.response.status == 401) {
            router.push({ name: "Login" });
        }
        if (err.response.status == 500) {
            EventBus.$emit("LogOutEventBus", false);
        }
    }
}